import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import api from "@/api/api.js";
import FiscalDocumentDownload from "./FiscalDocumentDownload.jsx";

const fmt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
};

const CertificateTaxStatus = ({ companyId, refreshKey }) => {
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get(`/companies/${companyId}/certificateTax/latest`)
      .then(({ data }) => {
        if (active) {
          setCertificate(data);
          setMissing(false);
        }
      })
      .catch(() => {
        if (active) setMissing(true);
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [companyId, refreshKey]);

  if (loading) {
    return (
      <div className="text-muted">
        <Spinner animation="border" size="sm" className="me-2" />
        Cargando constancia...
      </div>
    );
  }

  if (missing || !certificate) {
    return (
      <div className="text-muted">
        <i className="bi bi-exclamation-circle me-1" />
        No hay constancia de situación fiscal registrada.
      </div>
    );
  }

  const regimenes = Array.isArray(certificate.regimenes)
    ? certificate.regimenes
    : [];

  return (
    <div>
      <div className="row g-2 mb-3">
        <div className="col-sm-6">
          <small className="text-muted d-block">Archivo</small>
          <span>{certificate.fileIdentifier || "—"}</span>
        </div>
        <div className="col-sm-3">
          <small className="text-muted d-block">Versión</small>
          <span>{certificate.version ?? "—"}</span>
        </div>
        <div className="col-sm-3">
          <small className="text-muted d-block">Subida</small>
          <span>{fmt(certificate.createdAt)}</span>
        </div>
      </div>

      <div className="row g-2 mb-3">
        <div className="col-sm-6">
          <small className="text-muted d-block">Lugar de emisión</small>
          <span>{certificate.lugarEmision || "—"}</span>
        </div>
        <div className="col-sm-6">
          <small className="text-muted d-block">Fecha de emisión</small>
          <span>{certificate.fechaEmision || "—"}</span>
        </div>
      </div>

      <small className="text-muted d-block mb-1">Regímenes registrados</small>
      {regimenes.length === 0 ? (
        <p className="text-muted">—</p>
      ) : (
        <ul className="list-group mb-3">
          {regimenes.map((r, i) => (
            <li
              key={`${r.id}-${i}`}
              className="list-group-item d-flex justify-content-between align-items-start"
            >
              <span>
                {r.id ? `${r.id} — ` : ""}
                {r.descripcion || "—"}
              </span>
              {r.fechaAlta && (
                <small className="text-muted ms-2">Alta: {r.fechaAlta}</small>
              )}
            </li>
          ))}
        </ul>
      )}

      <FiscalDocumentDownload
        companyId={companyId}
        documentId={certificate.id}
        fileName={certificate.fileIdentifier || "constancia.pdf"}
      />
    </div>
  );
};

export default CertificateTaxStatus;
